// extracted by mini-css-extract-plugin
export default {"AlgoliaSearch":"AlgoliaSearch1uFG9utXJ4-6","AlgoliaSearch_withSidebar":"AlgoliaSearch_withSidebar29kYcdpc_WMH","AlgoliaSearch-Col":"AlgoliaSearch-Col2ycAQ9JMrSYg"};